import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  FormControl,
  Grid,
  Input,
  makeStyles,
  TextField,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import StyledCheckbox from '../../../../../utils/componentutils/StyledCheckbox';
import InfoIconComponent from './InfoIcon';

const useStyles = makeStyles((theme) => ({
  input: { fontSize: 10 },
}));
export default function RestartSettingsComponent({
  restartSettings,
  setRestartSettings,
}) {
  const classes = useStyles();
  const [maxLossTxt, setMaxLossTxt] = useState('');
  const [maxMinutesTxt, setMaxMinutesTxt] = useState('');
  const [maxAttemptsTxt, setAttemptsTxt] = useState('');
  const [maxTradesTxt, setMaxTradesTxt] = useState('');

  useEffect(() => {
    setMaxLossTxt(restartSettings.maxLoss);
    setMaxMinutesTxt(restartSettings.maxMinutesInTradePlan);
    setAttemptsTxt(restartSettings.maxRestartAttempts);
    setMaxTradesTxt(restartSettings.numberOfTrades);
  }, [restartSettings]);

  return (
    <div className="m-2">
      <Grid container>
        <Grid item xs={3}>
          <Typography style={{ fontSize: 14 }}>
            <u>
              <b>Restart Limits</b>
            </u>
          </Typography>
        </Grid>
        <Grid item xs={12} />
        <Grid item xs={12} container>
          <Grid item xs={4}>
            <FormControlLabel
              value="top"
              control={
                <StyledCheckbox
                  checked={restartSettings.deactivateOnRestart}
                  //                        checked={filterStatus === "active"}
                  onChange={(ev) => {
                    restartSettings.deactivateOnRestart = ev.target.checked;
                    let deepCopy = {};
                    Object.keys(restartSettings).forEach(
                      (key) => (deepCopy[key] = restartSettings[key])
                    );
                    setRestartSettings(deepCopy);
                  }}
                  //label="maxLossOn"
                  //name="maxLossOn"
                />
              }
              label={
                <Typography style={{ fontSize: 10 }}>
                  deactivate on restart
                  <InfoIconComponent docs={DeactivateOnRestartDocs} />
                </Typography>
              }
              labelPlacement="end"
            />
          </Grid>
        </Grid>
        <Grid item xs={3} container>
          <Grid item xs={12}>
            <FormControlLabel
              value="top"
              control={
                <StyledCheckbox
                  checked={restartSettings.isMaxLoss}
                  //                        checked={filterStatus === "active"}
                  onChange={(ev) => {
                    restartSettings.isMaxLoss = ev.target.checked;
                    let deepCopy = {};
                    Object.keys(restartSettings).forEach(
                      (key) => (deepCopy[key] = restartSettings[key])
                    );
                    setRestartSettings(deepCopy);
                  }}
                  //label="maxLossOn"
                  //name="maxLossOn"
                />
              }
              label={
                <Typography style={{ fontSize: 10 }}>
                  Max Loss
                  <InfoIconComponent docs={MaxLossDocs} />
                </Typography>
              }
              labelPlacement="end"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              size={'small'}
              onChange={(ev) => setMaxLossTxt(ev.target.value)}
              value={maxLossTxt}
              InputProps={{ classes: { input: classes.input } }}
              onBlur={(ev) => {
                restartSettings.maxLoss = parseFloat(ev.target.value);
                let deepCopy = {};
                Object.keys(restartSettings).forEach(
                  (key) => (deepCopy[key] = restartSettings[key])
                );
                setRestartSettings(deepCopy);
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs={3} container>
          <Grid item xs={12}>
            <FormControlLabel
              value="top"
              control={
                <StyledCheckbox
                  checked={restartSettings.isNumberOfTrades}
                  //                        checked={filterStatus === "active"}
                  onChange={(ev) => {
                    restartSettings.isNumberOfTrades = ev.target.checked;
                    let deepCopy = {};
                    Object.keys(restartSettings).forEach(
                      (key) => (deepCopy[key] = restartSettings[key])
                    );
                    setRestartSettings(deepCopy);
                  }}
                  //label="maxLossOn"
                  //name="maxLossOn"
                />
              }
              label={
                <Typography style={{ fontSize: 10 }}>
                  Max Trades
                  <InfoIconComponent docs={MaxAttemptsDocs} />
                </Typography>
              }
              labelPlacement="end"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              size={'small'}
              onChange={(ev) => setMaxTradesTxt(ev.target.value)}
              value={maxTradesTxt}
              InputProps={{ classes: { input: classes.input } }}
              onBlur={(ev) => {
                restartSettings.numberOfTrades = parseFloat(ev.target.value);
                let deepCopy = {};
                Object.keys(restartSettings).forEach(
                  (key) => (deepCopy[key] = restartSettings[key])
                );
                setRestartSettings(deepCopy);
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs={3} container>
          <Grid item xs={12}>
            <FormControlLabel
              value="top"
              control={
                <StyledCheckbox
                  checked={restartSettings.isMaxRestartAttempts}
                  //                        checked={filterStatus === "active"}
                  onChange={(ev) => {
                    restartSettings.isMaxRestartAttempts = ev.target.checked;
                    let deepCopy = {};
                    Object.keys(restartSettings).forEach(
                      (key) => (deepCopy[key] = restartSettings[key])
                    );
                    setRestartSettings(deepCopy);
                  }}
                  //label="maxLossOn"
                  //name="maxLossOn"
                />
              }
              label={
                <Typography style={{ fontSize: 10 }}>
                  Max Attempts
                  <InfoIconComponent docs={MaxAttemptsDocs} />
                </Typography>
              }
              labelPlacement="end"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              size={'small'}
              onChange={(ev) => setAttemptsTxt(ev.target.value)}
              value={maxAttemptsTxt}
              InputProps={{ classes: { input: classes.input } }}
              onBlur={(ev) => {
                restartSettings.maxRestartAttempts = parseFloat(
                  ev.target.value
                );
                let deepCopy = {};
                Object.keys(restartSettings).forEach(
                  (key) => (deepCopy[key] = restartSettings[key])
                );
                setRestartSettings(deepCopy);
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs={3} container>
          <Grid item xs={12}>
            <FormControlLabel
              value="top"
              control={
                <StyledCheckbox
                  checked={restartSettings.isMaxMinutesInTradePlan}
                  //                        checked={filterStatus === "active"}
                  onChange={(ev) => {
                    restartSettings.isMaxMinutesInTradePlan = ev.target.checked;
                    let deepCopy = {};
                    Object.keys(restartSettings).forEach(
                      (key) => (deepCopy[key] = restartSettings[key])
                    );
                    setRestartSettings(deepCopy);
                  }}
                  //label="maxLossOn"
                  //name="maxLossOn"
                />
              }
              label={
                <Typography style={{ fontSize: 10 }}>
                  Max Minutes
                  <InfoIconComponent docs={MaxMinutesDocs} />
                </Typography>
              }
              labelPlacement="end"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={maxMinutesTxt}
              size={'small'}
              onChange={(ev) => setMaxMinutesTxt(ev.target.value)}
              InputProps={{ classes: { input: classes.input } }}
              onBlur={(ev) => {
                restartSettings.maxMinutesInTradePlan = parseFloat(
                  ev.target.value
                );
                let deepCopy = {};
                Object.keys(restartSettings).forEach(
                  (key) => (deepCopy[key] = restartSettings[key])
                );
                setRestartSettings(deepCopy);
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

const DeactivateOnRestartDocs = (
  <p>
    When a tradePlan restarts, deactivate the trade plan. A button will appear
    that will allow you to activate the trade plan when you feel ready
  </p>
);
const MaxLossDocs = (
  <p>
    If a repeating trade plan exceeds this loss, the trade plan will terminate
  </p>
);
const MaxAttemptsDocs = (
  <p>Once a repeating trade plan has run this many times, it will terminate</p>
);
const MaxMinutesDocs = (
  <p>
    Once a repeating trade plan has run for this many minutes, it will
    terminate. Please note that this is evaluated at the close of a position for
    that trade plan. Therefore, if this value is set for 15, and a position is
    closed 13 minutes into the trade plan's existence, it will still run once
    more.{' '}
  </p>
);
